import { ConsolidatedContact } from '../../../../api/CoachingNotes/schema';
import {
  isConcessionComplianceCategory,
  isKudosCategory,
} from '../../../CoachingNotes/ConsolidatedContacts/Tab/Utils/FilterSortHelper';
import {
  SortableColumn,
  SortableDirection,
  customSort,
  RECOMMEND_SIZE,
  RECOMMEND_SIZE_WITH_SA,
  RECOMMEND_KUDO_COUNT,
  RECOMMEND_KUDO_COUNT_WITH_SA,
  PAGINATION_SIZE_WITH_SA_RECOMMENDED,
} from '../../../CoachingNotes/ConsolidatedContacts/Tab/TabHelper';

import { partitionArray } from '../../../../Util/Helper';

export interface ProcessedContact {
  pageSize: number;
  contacts: ConsolidatedContact[];
}

/**
 * This helper function is to provide Recommendation tab
 * filter and sorting logic to a list of contacts
 * @param contacts
 * @param concessionEnabled
 * @param speechAnalyticEnabled
 * @param sortColumn
 * @param sortDirection
 * @returns
 */
export const processContact = (
  contacts: ConsolidatedContact[],
  concessionEnabled: boolean = false,
  speechAnalyticEnabled: boolean = false,
  sortColumn: SortableColumn = SortableColumn.INIT,
  sortDirection: SortableDirection = SortableDirection.DECENDING
): ProcessedContact => {
  const preprocessedContacts = concessionEnabled
    ? contacts
    : contacts.filter(contact => !isConcessionComplianceCategory(contact));

  const sortedContacts = preprocessedContacts.sort(
    (noteA: ConsolidatedContact, noteB: ConsolidatedContact) =>
      customSort(sortColumn, sortDirection, noteA, noteB)
  );

  const [kudosContacts, nonKudosContacts] = partitionArray(
    sortedContacts,
    isKudosCategory
  );

  const concessionContactCount = nonKudosContacts.filter(
    (c: ConsolidatedContact) => isConcessionComplianceCategory(c)
  ).length;

  const RECOMMEND_REGULAR_COUNT =
    concessionContactCount +
    (speechAnalyticEnabled
      ? RECOMMEND_SIZE_WITH_SA - RECOMMEND_KUDO_COUNT_WITH_SA
      : RECOMMEND_SIZE - RECOMMEND_KUDO_COUNT);

  const PAGE_SIZE = speechAnalyticEnabled
    ? PAGINATION_SIZE_WITH_SA_RECOMMENDED
    : RECOMMEND_REGULAR_COUNT + RECOMMEND_KUDO_COUNT;

  const reorganizedContacts = [
    ...nonKudosContacts.slice(0, RECOMMEND_REGULAR_COUNT),
    ...(speechAnalyticEnabled
      ? kudosContacts.slice(0, RECOMMEND_KUDO_COUNT_WITH_SA)
      : kudosContacts.slice(0, RECOMMEND_KUDO_COUNT)),
  ];

  return { pageSize: PAGE_SIZE, contacts: reorganizedContacts };
};
